module.exports = __webpack_public_path__ + "img/logo_head.12b12c96.svg";